import { styled } from '@mui/material';

export const Layout = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  flex-direction: column;
`;

export const Field = styled('fieldset')`
  border: 0;
  padding: 0 0 4px;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 26px;
`;
